/*
document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll('.homepage_tabbed_tabs li');

  if (!tabs.length) return; // ← prevent crash

  const middleIndex = Math.floor(tabs.length / 2);

  tabs.forEach(li => li.classList.remove('active'));
  tabs[middleIndex].classList.add('active');
});
*/
jQuery(document).on('click', '.header-sidebar__linklist-bton', function(){
        document.querySelector('header-sidebar').hide();

}); 

/* ================================
   Flickity: site-wide robust init
 end   ================================ */
document.addEventListener("DOMContentLoaded", function() {
  var carouselElems = document.querySelectorAll('.carousel:not([data-fcp-carousel])');

  carouselElems.forEach(function(el) {
    if (typeof Flickity === 'undefined' || Flickity.data(el)) return;

    var flkty = new Flickity(el, {
      cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      prevNextButtons: true,
      pageDots: true
    });

    // Store flickity instance
    el.flickity = flkty;

    if (typeof imagesLoaded === 'function') {
      imagesLoaded(el, function() {
        flkty.resize();
        flkty.reposition();
      });
    }
  });
});

// Handle Shopify section reloads
document.addEventListener('shopify:section:load', function(event) {
  var carousels = event.target.querySelectorAll('.carousel');
  carousels.forEach(function(c) {
    if (c.flickity) {
      c.flickity.resize();
      c.flickity.reposition();
    }
  });
});

// Extra safety: resize on window load
window.addEventListener("load", function() {
  var carousels = document.querySelectorAll('.carousel');
  carousels.forEach(function(c) {
    if (c.flickity) {
      c.flickity.resize();
      c.flickity.reposition();
    }
  });
});

$(document).ready(function() {
 $('.sticky-left p a').first().addClass('active');

  // Run only on desktop (width > 1024px)
 /* if ($(window).width() > 1024) {
    $('.header__menu-disclosure').hover(
      function() {
        $('x-header').addClass('is-solid'); // On hover in
      },
      function() {
        $('x-header').removeClass('is-solid'); // On hover out
      }
    );
  } */


$('.sticky-left a').on('click', function (e) {
  e.preventDefault();

  var offset = 150;
  var targetId = $(this).attr('href');

  $('html, body').animate({
    scrollTop: $('.col-right h3' + targetId).offset().top - offset
  }, 500);
});

$(window).on("scroll", function () {
  var section = $("[id*='__image_with_text_block_iaPHED']");
  if (!section.length) return;
  var sectionTop = section.offset().top;
  var scrollPos = $(window).scrollTop() + $(window).height() - 150;

  if (scrollPos > sectionTop) {
    section.addClass("active");
  }
});

});

//legal pages bold for tab section
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.two-col-title');
  const sections = document.querySelectorAll('.col-right h3');

  // Click highlight
  links.forEach(link => {
    link.addEventListener('click', () => {
      links.forEach(l => l.classList.remove('active'));
      link.classList.add('active');
    });
  });

  // Scroll highlight
  window.addEventListener('scroll', () => {
    let current = '';

    sections.forEach(section => {
      const sectionTop = section.offsetTop - 120;
      if (window.scrollY >= sectionTop) {
        current = section.getAttribute('id');
      }
    });

    links.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('href') === '#' + current) {
        link.classList.add('active');
      }
    });
  });
});



//UGS
/* =========================================
   COUTURE HASH → STRUCTURED SLIDER TAB
   Production-optimized & conflict-safe
========================================= */

(function () {

  const SCROLL_OFFSET = 100;
  const COUTURE_PATH = '/pages/couture/';

  function activateTab(hash) {
    const key = hash?.replace('#', '').toLowerCase();
    if (!key) return;

    const slider = document.querySelector('.structured-slider');
    const tab = slider?.querySelector(`.slider-tab[data-key="${key}"]`);
    if (!tab) return;

    tab.click();

    const y = slider.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function waitForSlider(hash) {
    const existing = document.querySelector('.structured-slider .slider-tab');
    if (existing) return setTimeout(() => activateTab(hash), 80);

    const observer = new MutationObserver(() => {
      if (document.querySelector('.structured-slider .slider-tab')) {
        observer.disconnect();
        setTimeout(() => activateTab(hash), 80);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Menu click ---------- */
  document.addEventListener('click', (e) => {

    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const url = new URL(link.href, location.origin);

    if (!url.pathname.includes(COUTURE_PATH) || !url.hash) return;

    if (!location.pathname.includes(COUTURE_PATH)) {
      sessionStorage.setItem('coutureHash', url.hash);
      return; // allow navigation
    }

    e.preventDefault();
    history.pushState(null, '', url.hash);
    waitForSlider(url.hash);
  });

  /* ---------- Page load ---------- */
  document.addEventListener('DOMContentLoaded', () => {

    if (!location.pathname.includes(COUTURE_PATH)) return;

    const stored = sessionStorage.getItem('coutureHash');
    const hash = stored || location.hash;
    if (!hash) return;

    sessionStorage.removeItem('coutureHash');
    waitForSlider(hash);
  });

})();

//UGS - added this code on if user not on very top, add is-solid class
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("x-header.header");
  if (!header) return;

  function updateHeaderState() {
    header.classList.toggle("is-solid", window.scrollY > 0);
  }

  // Scroll + resize
  window.addEventListener("scroll", updateHeaderState, { passive: true });
  window.addEventListener("resize", updateHeaderState);

  // Extra safety: mouse move & touch
  window.addEventListener("mousemove", updateHeaderState);
  window.addEventListener("touchstart", updateHeaderState);

  // Initial check
  updateHeaderState();
});

//UGS for Calendly link on contact page and JS and CSS is loaded on theme.liquid file
document.addEventListener("click", function (e) {
  const btn = e.target.closest('a[href="#book-an-appointment"]');
  if (!btn) return;

  e.preventDefault();

  function openCalendly() {
    if (typeof Calendly !== "undefined") {
      Calendly.initPopupWidget({
        url: "https://calendly.com/hueb/30min"
      });
    } else {
      setTimeout(openCalendly, 200);
    }
  }

  openCalendly();
});

/* Run on normal page load */
document.addEventListener("DOMContentLoaded", initCalendlyButton);

/* Run again for Shopify dynamic sections / AJAX navigation */
document.addEventListener("shopify:section:load", initCalendlyButton);
document.addEventListener("shopify:section:reorder", initCalendlyButton);


/* =========================================
   PRESTIGE MOBILE SIDEBAR → FULL CLOSE FIX
========================================= */

(function () {

  function isMobile() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }

  document.addEventListener('click', function (e) {

    if (!isMobile()) return;

    const link = e.target.closest('#sidebar-menu a[href*="#"]');
    if (!link) return;

    // Allow your couture + hash logic to run first
    setTimeout(function () {

      const sidebar = document.getElementById('sidebar-menu');
      if (!sidebar) return;

      // 🔥 THIS is the real close trigger
      sidebar.removeAttribute('open');

      // Safety cleanup
      sidebar.style.display = '';
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');

    }, 120);

  });

})();


/* ===============================
   Calendly Popup Trigger
================================ */

document.addEventListener("click", function (e) {
  const btn = e.target.closest('a[href*="#book-an-appointment"]');
  if (!btn) return;

  e.preventDefault();

  function openCalendly() {
    if (window.Calendly && Calendly.initPopupWidget) {
      Calendly.initPopupWidget({
        url: "https://calendly.com/hueb/30min"
      });
    } else {
      setTimeout(openCalendly, 300);
    }
  }

  openCalendly();
});

